import { Factory } from 'fishery'

import {
  AddressResponseV1,
  AddressSource,
  PickupDeliveryLocationListResponseV1,
  PickupDeliveryLocationResponseV1,
  PickupDeliveryLocationStatus,
  PickupDeliveryLocationValidationType,
} from '@forto-dev/customer-master-data-models'

export const addressResponseFactory = Factory.define<AddressResponseV1>(() => ({
  companyName: null,
  route1: null,
  route2: null,
  route3: null,
  route4: null,
  additionalInformation: null,
  locality1: null,
  locality2: null,
  locality3: null,
  locality4: null,
  region1: null,
  region2: null,
  region3: null,
  region4: null,
  postalCode: null,
  coordinates: null,
  countryCode: 'DE',
  countryName: 'Germany',
  locationRef: null,
  source: AddressSource.AUTOCOMPLETE,
  hasCompleteAddress: false,
}))

export const pickupDeliveryLocationResponseV1Factory = Factory.define<PickupDeliveryLocationResponseV1>(
  ({ sequence }) => {
    return {
      id: `L${sequence}`,
      locationName: `Location ${sequence}`,
      accountID: `C-${sequence}`,
      organizationID: `O${sequence}`,
      address: addressResponseFactory.build(),
      addressFormatted: 'Some formatted address',
      localAddress: addressResponseFactory.build(),
      localAddressFormatted: 'Some local formatted address',
      locationType: [],
      notes: 'Some notes',
      unLocode: null,
      contactIDs: [],
      legalEntityIDs: [],
      validationType: PickupDeliveryLocationValidationType.VERIFIED,
      status: PickupDeliveryLocationStatus.ACTIVE,
      inactiveReason: null,
      references: [],
      createdAt: new Date().toISOString(),
      createdBy: 'some-user-id',
      updatedAt: new Date().toISOString(),
      updatedBy: 'some-user-id',
      deletedAt: null,
      deletedBy: null,
      deleteReason: null,
      successorLocationID: null,
      predecessorLocationIDs: [],
    }
  }
)

export const pickupDeliveryLocationListResponseV1Factory = Factory.define<PickupDeliveryLocationListResponseV1>(() => {
  return {
    items: pickupDeliveryLocationResponseV1Factory.buildList(1),
    total: 1,
  }
})
